import * as React from "react";
import {BrowserRouter} from "react-router-dom";
import Router from "./router";
import {createTheme} from "@mui/material/styles";
import {ThemeProvider} from "@mui/material";
import Keycloak from 'keycloak-js';
import { ReactKeycloakProvider } from "@react-keycloak/web"
import { setTokenToStorage } from "./api/authStorage/storageTokenOperations";
import { APIProvider } from '@vis.gl/react-google-maps';
  
const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL ? process.env.REACT_APP_KEYCLOAK_URL : 'http://localhost:8282',
    realm: process.env.REACT_APP_KEYCLOAK_REALM ? process.env.REACT_APP_KEYCLOAK_REALM : 'master',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ? process.env.REACT_APP_KEYCLOAK_CLIENT_ID : 'frontend-debug'
});

const theme = createTheme({});

const eventLogger = (event, error) => {
 // console.log('onKeycloakEvent', event, error)
}

const tokenLogger = (tokens) => {
 // console.log('onKeycloakTokens', tokens)
}

function App() {
	//useFetchUIConfig();

	return (
		<BrowserRouter>
			<ThemeProvider theme={theme}>
				<APIProvider apiKey={'AIzaSyBqzLyWZhoK1UyPtyubsK5bZwBlzs0_p5w'}>
		        	<ReactKeycloakProvider authClient={keycloak} onTokens={tokenLogger} onEvent={eventLogger}>
						<Router/>
					</ReactKeycloakProvider>
				</APIProvider>
			</ThemeProvider>
		</BrowserRouter>
    );

}

export default App;
